const locationsReducer = (
  state = {
    loading: false,
    data: null,
    currentLocation: null,
    distance: null
  },
  action
) => {
  switch (action.type) {
    case "SET_LOCATIONS_LOADING":
      return {
        ...state,
        loading: action.payload.loading
      };

    case "SET_LOCATIONS_DATA":
      return {
        ...state,
        data: action.payload.data
      };

    // The locations catalog is the public site list - identical for every user
    // (see useLocationListener's access == "public" query), so it survives logout
    // to avoid re-waiting on the listener. Per-session selection does not.
    case "RESET":
      return {
        loading: false,
        data: state.data,
        currentLocation: null,
        distance: null,
        selectedLocation: null
      };

    case "SET_USER_DISTANCE":
      return {
        ...state,
        distance: action.payload.distance
      };

    case "SET_USER_CURRENT_LOCATION":
      return {
        ...state,
        currentLocation: action.payload.data
      };

    case "SET_SELECTED_LOCATION":
      return {
        ...state,
        selectedLocation: action.payload.data
      };

    default:
      return state;
  }
};
export default locationsReducer;
